<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addPrice, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    //- modal-import(model="" :title="$t('front.import_modal', {model: $t('strings.')})")
    //- modal-prices(:newRecord='newRecord', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-tabs
          vm-tab(vm-label='Casas' @click="flag = true")
            vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
              div
                h2 {{ $t('prices.costs') }}:
                span {{ $t('prices.admin', {attribute: $t('prices.costs')}) }}
                //- vm-button(type="default" icon="list")
                //- vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")

            cost-updater(:key='index' :newRecord="item" :title='item.title' v-for='item,index in prices')

            //- cost-updater(title="Molino de Agua" :newRecord="newRecord")
          vm-tab(vm-label='Terrenos' @click="flag = false")
            vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
              div
                h2 {{ $t('prices.costs') }}:
                span {{ $t('prices.admin', {attribute: $t('prices.costs')}) }}
                //- vm-button(type="default" icon="list")
                //- vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")

            cost-updater(:key='index' :newRecord="item" :title='item.title' v-for='item,index in pricesGround')
</template>

<script>
import ModalPrices from '@/components/modals/ModalPrices.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import CostUpdater from '@/components/aditionals/CostUpdater.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Prices')

export default {
  name: 'Prices',
  components: {
    ModalPrices,
    ModalImport,
    CostUpdater
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    flag: false,
    newRecord: [{
      price_in_front_of_park: '',
      reservation_price: '',
      discount_voucher: ''
    }],
    selected: [],
    columns: [
      // Agrega las columnas a mostrar
      'price_in_front_of_park',
      'reservation_price',
      'discount_voucher'
    ],
    columnsOrderBy: [
      // Nota solo si las columnas son atributos
    ],
    status: [
      // Agregar los estatus si maneja
      // {
      //   text: 'Pagado',
      //   value: 2,
      //   color: 'warning'
      // }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        // Agregar las columnas que se filtraran en el buscador
        // name_last_name: [
        //  'name',
        //  'last_name'
        // ],
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    this.applyFilter(this.filters)
    await this.getPrices(1)
    await this.loadPricesGround()
    // await this.getPricesCatalog()
  },
  watch: {
    currentPage (currentPage) {
      this.getPrices(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getPrices(this.currentPage)
    }
  },
  methods: {
    ...mapActions([
      'deletePrice',
      'deletePrices',
      'loadPrices',
      'loadPricesGround',
      'loadCatalog',
      'loadMaps',
      'getPricesCatalog',
      'actionPrice',
      'setModalImportVisible',
      'setModalVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    async getMaps (page) {
      this.loadMaps()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.prices.findIndex(u => u.id === this.selected[0].id)
      this.editPrice(this.selected[0], idx)
    },
    addPrice () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
    },
    editPrice (price, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.newRecord = { ...price }
    },
    async deletePriceConfirm (price) {
      let t = this
      this.auxDeletePrice = () => {
        t.deletePrice(price).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.'), attribute: this.$t(price.id/* columna */) }),
        accept: this.auxDeletePrice
      })
    },
    async deletePricesConfirm () {
      let t = this
      let pricesMany = parseDeleteMany(this.selected /* 'columna' */)
      this.auxDeletePrice = () => {
        t.deletePrices(pricesMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.prices'), attribute: pricesMany.values }),
        accept: this.auxDeletePrice
      })
    },
    async setActionPrice (record, action) {
      record.id && this.actionPrice({ id: record.id, action })
    },
    async getPrices (page) {
      let t = this
      this.loadPrices({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let price = this.prices.filter(price => price.id === parseInt(index))[0]
      price && this.editPrice(price, index)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  },
  computed: {
    ...mapGetters([
      'prices',
      'pricesGround',
      'pagination',
      'filterParams',
      'maps'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('prices.' + column)}` : `${str} ${t.$t('prices.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.price'), columns: concatColumns, column: this.$t('prices.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.pad {
  padding: 20px !important;
}
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  float: left;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
